import { useState } from "react";
import { T, MANROPE, FOCUS, ddMon } from "./todoTokens";

/* Moving a date that was already set has to be explained, and the reason is
   recorded against the item. Anthony Roche never sees this. */
export const DueReasonDialog = ({ from, to, count, onCancel, onConfirm }) => {
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);
  const go = async () => {
    const r = reason.trim();
    if (!r) return;
    setSaving(true);
    try { await onConfirm(r); } finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-[90] flex items-start justify-center px-4 py-24" data-testid="due-reason-dialog">
      <div className="absolute inset-0" style={{ background: "rgba(18,18,18,0.32)" }} onClick={onCancel} />
      <div className="relative rounded-[12px] w-full max-w-[440px] bg-white overflow-hidden"
        style={{ border: `1px solid ${T.cardEdge}` }}
        onKeyDown={(e) => { if (e.key === "Escape") onCancel(); }}>
        <div className="px-5 pt-4 pb-3" style={{ borderBottom: `1px solid ${T.rule}` }}>
          <div style={{ ...MANROPE, fontSize: 17, fontWeight: 800, color: T.ink }}>Why is this date moving?</div>
          <div className="text-[12.5px] mt-0.5" style={{ color: T.ink2 }}>
            {count > 1
              ? `${count} to-dos move to ${ddMon(to)}. The reason is recorded on each one.`
              : `${from ? `${ddMon(from)} → ` : ""}${ddMon(to)} · the reason is recorded against this to-do.`}
          </div>
        </div>
        <div className="px-5 py-4">
          <textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={3} autoFocus
            placeholder="e.g. client hasn't sent the data file yet"
            className={`w-full rounded-[7px] px-2.5 py-2 text-[13px] ${FOCUS}`}
            style={{ border: "1px solid #C9C3B6", color: T.ink }} data-testid="due-reason-text" />
        </div>
        <div className="px-5 py-3 flex items-center justify-end gap-2" style={{ borderTop: `1px solid ${T.rule}` }}>
          <button onClick={onCancel} className="h-9 px-3 text-[13px]" style={{ color: T.ink2 }}
            data-testid="due-reason-cancel">Cancel</button>
          <button onClick={go} disabled={!reason.trim() || saving} data-testid="due-reason-save"
            className="h-9 px-4 rounded-[7px] text-[12.5px] font-bold disabled:opacity-60"
            style={{ background: reason.trim() ? T.accent : "#E6E2D9", border: `1px solid ${T.accentEdge}`, color: T.accentInk }}>
            {saving ? "Saving…" : "Move the date"}
          </button>
        </div>
      </div>
    </div>
  );
};
